module.exports = __webpack_public_path__ + "img/start-call.b6780675.svg";